import { BlindType } from '../../model/enumeration/BlindType.enum';
import { GameStage } from '../../model/enumeration/GameStage.enum';
import { PlayerActionType } from '../../model/enumeration/PlayerActionType.enum';
import { LogEvent } from '../../model/LogsResponse';
import { Player } from '../../model/Player';
import eventLogsStore from '../../store/EventLogsStore';
import gameStore from '../../store/GameStore';
import playerActionStore from '../../store/PlayerActionStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WBlindEvent extends WEvent {
  gameId: string;
  pid: string;
  blindType: BlindType;
  allIn: boolean;
  value: number;
  stack: number;
  totalBet: number;
  pot: number;

  constructor(event: WBlindEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  public applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      if (this.blindType === BlindType.TYPE_STRADDLE) {
        playerActionStore.addPlayerAction({
          pid: this.pid,
          action: PlayerActionType.STRADDLE,
          bet: this.value,
          tableId: this.tableId,
        });
      }
      game.setPlayers(
        playerStore.modifyPlayers(game.players, this.pid, player => {
          player.stack = this.stack;
          player.allIn = this.allIn;
          player.totalBet = this.totalBet;
          player.notParticipating = false;

          if (
            this.blindType !== BlindType.TYPE_ANTE &&
            !player.blinds.find(blind => blind === this.blindType)
          ) {
            player.blinds = [...player.blinds, this.blindType];
          }
          this.addEventToLog(player);
        }),
      );
      game.setPot(this.pot);

      game.resetActivePlayer();
    });

  private addEventToLog = (player: Player): void => {
    const eventLog = { blinds: [] } as LogEvent;
    eventLog.pid = this.pid;
    eventLog.nick = player.nick;
    eventLog.blinds.push(this.blindType);
    eventLog.value = this.value;
    eventLog.allIn = this.allIn;
    eventLog.myBot = player.myBot;
    eventLog.action = this.blindType;
    eventLog.pot = this.pot;
    eventLogsStore.addEventToLog(this.tableId, eventLog, GameStage.BLINDS);
  };
}
